import { i18next, saving } from '@yola/ws-sdk';
import store from 'src/js/store';
import { saveSiteWithEffect } from 'src/js/modules/saving/helpers/save-site';

const { SAVED, SAVING } = saving.constants.statuses;

const getStatus = () => saving.selectors.getStatus(store.getState());

const waitForSaveToFinish = () =>
  new Promise((resolve) => {
    if (getStatus() !== SAVING) {
      resolve();
      return;
    }

    const unsubscribe = store.subscribe(() => {
      if (getStatus() === SAVING) return;

      unsubscribe();
      resolve();
    });
  });

// Answers the chat's `save` request. Resolves once the site is saved, rejects
// otherwise — with a message the chat shows to the user as-is.
const saveSiteForChat = async () => {
  // A save already in flight may cover everything; if it fails, or changes
  // land while it runs, the save below picks up the rest.
  await waitForSaveToFinish();

  if (getStatus() === SAVED) return;

  try {
    await saveSiteWithEffect();
  } catch (e) {
    console.error('Error saving the site requested by AI chat', e);
  }

  if (getStatus() !== SAVED) {
    throw new Error(i18next.t("Your changes couldn't be saved. Please try again."));
  }
};

export default saveSiteForChat;
